export default "__VITE_ASSET__D2SIo43c__"